// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.CartPage.RelatedItemsView.Collection'
,	[
	   'Item.Collection'	
    ]
, function (
	ItemCollection
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
	return ItemCollection.extend({
    initialize: function(options) {
        this.searchApiMasterOptions = options.configuration.searchApiMasterOptions.relatedItems;
        this.itemsIds = _.isArray(options.itemsIds)
            ? _.sortBy(options.itemsIds, function(id) {
                  return id;
              })
            : [options.itemsIds];
    },

    // @method fetchItems @return {jQuery.Deferred}
    fetchItems: function() {
        return this.fetch({ data: { id: this.itemsIds.join(',') } });
    },

    // http://backbonejs.org/#Model-parse
    parse: function(response) {
        const original_items = _.compact(response.items);

        if (original_items.length === 0) {
            return []; // No items. Return an empty array, nothing else to do here.
        }

        if (original_items.length === 1) {
            return (original_items[0]).relateditems_detail; // Same order is preserved.
        }

        // This is to avoid repeated related items among different items. (Cart page)
        const self = this;
        const items = {};

        _.each(_.pluck(original_items, 'relateditems_detail'), function(related_items) {
            _.each(related_items, function(related_item) {
                if (
                    !_.contains(self.itemsIds, related_item.internalid) &&
                    !items[related_item.internalid]
                ) {
                    items[related_item.internalid] = related_item;
                }
            });
        });

        return _.toArray(items);
    }

	});
});
